<button [type]="type" [disabled]="disabled || false" [class]="getStyle()" (click)="onClick($event)"
  [ngClass]="{ notActive: borderNone }" class="button">
  <ng-content></ng-content>
</button>